import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { create, findByIdAndSend } from '../../../actions/notificacao'
import { findById as findCondominioById } from '../../../actions/condominio'
import { find as findUnidadeByCondominioId } from '../../../actions/unidade'
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Icon, Form, Button, Modal } from 'semantic-ui-react';
import CamposNotificacao from './CamposNotificacao';
import { CabecalhoForm, RodapeForm } from '../../layouts/FormUI';
import Erro from '../../layouts/mensagens/Erro';
import * as FormValidator from "../../../utils/formValidator";

const URL_MODELO = 'https://voteassembleia.s3.us-east-2.amazonaws.com/modelos/Edital+de+Convocac%CC%A7a%CC%83o.docx';

class CadastrarNotificacao extends Component {

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      notificacao: {
        arquivo: '',
        usuario: '',
        unidades: [],
        votacao: '',
        tipo: 'CONVOCATION',
        mensagem: '',
      },
      errors: {},
      loading: false,
      notificacaoId: null,
      perguntarEnvio: false,
      enviando: false,
      erroEnvio: '',
    };
    this.pararBusca = this.pararBusca.bind(this);
  }

  componentDidMount = async () => {
    await this.props.findCondominioById(this.props.match.params.id);
    await this.props.findUnidadeByCondominioId(this.props.match.params.id);
    this.setState({
      notificacao: { ...this.state.notificacao, condominio: this.props.condominio._id },
      errors: this.props.errorsCondominio
    })
  };

  pararBusca = () => {
    clearTimeout(this.state.busca);
  };

  validate = notificacao => {
    const errors = {};

    if (FormValidator.isVazio(notificacao.tipo)) {
      errors.tipo = 'Tipo é obrigatório';
    }

    if (!FormValidator.isVazio(notificacao.link) && !FormValidator.isUrl(notificacao.link)) {
      errors.link = 'Url inválida';
    }

    if (FormValidator.isVazio(notificacao.mensagem) && !this.state.file) {
      errors.mensagem = 'Adicione uma mensagem ou arquivo';
    }

    return errors;
  };

  onChangeFile = e => {
    const mime = ['application/pdf'];
    if (e.target.files && e.target.files[0]) {
      const type = e.target.files[0].type;
      if (mime.indexOf(type) !== -1 || type.substr(0, 5) === 'image') {
        if (FormValidator.sizeLimit(e.target.files[0], process.env.REACT_APP_LIMIT_UPLOAD)) {
          this.setState({
            file: e.target.files[0],
            errors: {},
          });
        } else {
          this.setState({
            errors: {
              arquivo: `Permitido arquivos de até ${process.env.REACT_APP_LIMIT_UPLOAD}mb`
            }
          });
        }
      }
    }
  };

  onChangeSelect = (_, { name, value }) =>
    this.setState({
      notificacao: { ...this.state.notificacao, [name]: value },
      errors: {}
    });

  onChange = e =>
    this.setState({
      notificacao: { ...this.state.notificacao, [e.target.name]: e.target.value },
      errors: {}
    });

  getTipos = () => [
    { key: 'DEFAULT', value: 'DEFAULT', text: 'Padrão' },
    { key: 'CONVOCATION', value: 'CONVOCATION', text: 'Convocação' },
  ];

  getUnidades = unidades =>
    unidades.map(unidade => ({
      key: unidade._id,
      value: unidade._id,
      text: `${unidade.bloco} ${unidade.numero}`,
    }));

  fileUpload = file => {
    const formData = new FormData();
    formData.append('arquivo', file);
    Object.keys(this.state.notificacao).forEach(item => {
      formData.append(item, this.state.notificacao[item]);
    });
    return formData;
  };

  onSubmitCadastrar = async e => {
    e.preventDefault();
    const errors = this.validate(this.state.notificacao);
    this.setState({ errors });

    if (FormValidator.objIsEmpty(errors)) {
      this.setState({ loading: true });
      const resposta = await this.props.create(this.fileUpload(this.state.file));
      const salvou = FormValidator.objIsEmpty(this.props.errors);
      const notificacaoId = resposta && resposta.notificacao ? resposta.notificacao._id : null;
      this.setState({
        loading: false,
        notificacaoId,
        perguntarEnvio: salvou && !!notificacaoId,
        errors: this.props.errors
      });
      if (salvou && !notificacaoId) this.irParaLista();
    }
  };

  irParaLista = () => this.props.history.push(this.getVoltar());

  getVoltar = () => `/condominios/${this.props.condominio._id || this.props.match.params.id}/notificacoes`;

  enviarAgora = async () => {
    this.setState({ enviando: true, erroEnvio: '' });
    await this.props.findByIdAndSend(this.state.notificacaoId);
    const { errors } = this.props;
    if (FormValidator.objIsEmpty(errors)) {
      this.irParaLista();
      return;
    }
    this.setState({
      enviando: false,
      erroEnvio: errors.global || errors.error || 'Não foi possível enviar a notificação. Você pode tentar novamente pela lista de notificações.'
    });
  };

  render() {
    const { notificacao, errors, loading, file, perguntarEnvio, enviando, erroEnvio } = this.state;
    const { condominio, unidades } = this.props;

    const voltar = this.getVoltar();

    return (
      <div>
        {!!errors.global && <Redirect to="/" />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} loading={loading} />
          <div className="va-imp-pagina">
            <CabecalhoForm voltar={voltar} voltarTexto="Convocação digital" titulo="Cadastrar notificação" descricao="Envie um aviso, edital ou documento para os moradores pelo aplicativo." />
            {!!errors.error && <Erro text={errors.error} tipo="block" />}
            {(
              <Form onSubmit={this.onSubmitCadastrar} loading={loading} autoComplete="off" className="va-imp">
                <CamposNotificacao
                  notificacao={notificacao}
                  file={file}
                  errors={errors}
                  tipos={this.getTipos()}
                  unidadesOpcoes={this.getUnidades(unidades)}
                  arquivoAtualUrl={null}
                  modeloUrl={URL_MODELO}
                  onChange={this.onChange}
                  onChangeSelect={this.onChangeSelect}
                  onChangeFile={this.onChangeFile}
                />
                <RodapeForm>
                  <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                    <Icon name="save" /> Salvar notificação
                  </Button>
                  <Link to={voltar} className="ui basic large button">Cancelar</Link>
                </RodapeForm>
              </Form>
            )}
            <Modal size="tiny" open={perguntarEnvio} closeOnDimmerClick={false} closeOnEscape={false}>
              <Modal.Header>Notificação salva</Modal.Header>
              <Modal.Content>
                <p>Deseja enviar esta notificação agora para as unidades votantes?</p>
                <p>Os moradores receberão no aplicativo e por e-mail.</p>
                {!!erroEnvio && <Erro text={erroEnvio} tipo="block" />}
              </Modal.Content>
              <Modal.Actions>
                <Button basic onClick={this.irParaLista} disabled={enviando}>{erroEnvio ? 'Fechar' : 'Agora não'}</Button>
                <Button positive onClick={this.enviarAgora} loading={enviando} disabled={enviando}>
                  <Icon name="send" /> {erroEnvio ? 'Tentar novamente' : 'Enviar agora'}
                </Button>
              </Modal.Actions>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  notificacao: state.notificacao.notificacao,
  errors: state.notificacao.errors,
  condominio: state.condominio.condominio,
  unidades: state.unidade.unidades,
  errorsCondominio: state.condominio.errors
});

const mapDispatchToProps = dispatch => bindActionCreators({ create, findByIdAndSend, findCondominioById, findUnidadeByCondominioId }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarNotificacao);
